export default "__VITE_ASSET__nZ0rY$3T__"